import { useResetPassword } from '../../../hooks';
import { Button } from '../../ui';

export function ResetPassword() {
   const { userPasswordResetForm, isLoading, submitResetPassword } = useResetPassword();

   return (
      <div className="box bg-gray">
         <form
            onSubmit={userPasswordResetForm.handleSubmit(submitResetPassword)}
            className="signup-form flex flex-col gap-3">
            <div className="flex flex-col gap-3">
               <div className="form-group">
                  <label htmlFor="add-email-password">New Password</label>
                  <input
                     type="password"
                     id="add-email-password"
                     {...userPasswordResetForm.register('newPassword')}
                     className={userPasswordResetForm.formState.errors.newPassword ? 'error-input' : ''}
                  />
                  {userPasswordResetForm.formState.errors.newPassword && <p className="error-message">{userPasswordResetForm.formState.errors.newPassword.message as string}</p>}
               </div>
               <div className="form-group">
                  <label htmlFor="add-email-password-confirmation">Confirm New Password</label>
                  <input
                     type="password"
                     id="add-email-password-confirmation"
                     {...userPasswordResetForm.register('confirmPassword')}
                     className={userPasswordResetForm.formState.errors.confirmPassword ? 'error-input' : ''}
                  />
                  {userPasswordResetForm.formState.errors.confirmPassword && (
                     <p className="error-message">{userPasswordResetForm.formState.errors.confirmPassword.message as string}</p>
                  )}
               </div>

               <Button
                  title="Reset Password"
                  buttonType="submit"
                  type="white-big"
                  className="submit-button"
                  disabled={!userPasswordResetForm.formState.isValid}
                  loading={isLoading}
               />
            </div>
         </form>
      </div>
   );
}
